<section class="explore-more-section">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center mb-5">
        <h3 class="explore-heading">Explore Our Other Industries</h3>
      </div>
    </div>

    <div class="industries-grid">
      <!-- Changed to div with click event to match services behavior -->
      <div *ngFor="let industry of filteredIndustries" 
           (click)="navigateToIndustry(industry.path)" 
           class="industry-card">
        <div class="icon-wrapper">
          <img [src]="industry.icon" [alt]="industry.name" class="industry-icon">
        </div>
        <div class="industry-info">
          <span class="industry-name">{{ industry.name }}</span>
        </div>
      </div>
    </div>
  </div>
</section>